<template>
  <div id="app">
    <div :class="{
      appContainer : true,
      flexit: ($route.name == 'Intro')
    }">
      <Header />

      <router-view />
    </div>
    <BottomBar v-if="$route.meta.bottomLayout != 'none'" />

    <!--
    <div v-if="showInstallPrompt" class="install-container">
      <button class="install" @click="install">Installa applicazione</button>
    </div>

    <div v-if="showOpenApp" class="install-container">
      <div class="message">
        <h2>App installata!</h2>
        <p>
          <br />Hai installato questa app sul tuo dispositivo, avviala direttamente dalla tua home.
        </p>
      </div>
    </div>-->
  </div>
</template>

<style lang="less">
.appContainer {
  flex: 1;
  overflow: auto;
}

.flexit {
  display: flex;
  flex-direction: column;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
}

.install-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(235, 178, 141, 0.8);
  z-index: 999999;
  display: flex;
  align-items: center;

  justify-content: center;
}
.install {
  background: #fff;
  border: none;
  padding: 1em 2em;
  font-size: 1.2em;
  font-weight: bold;
  border-radius: 2em;
  color: #666;
  box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.2);
}
.message {
  background: #fff;
  padding: 30px;
  margin: 30px;
  box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.2);
  border-radius: 2em;
  p {
    color: #666;
    font-size: 1.2em;
    line-height: 1.5em;
  }
}
</style>

<script>
let deferredPrompt;

export default {
  name: "App",
  components: {
    BottomBar: () => import("@/components/BottomBar.vue"),
    Header: () => import("@/components/Header.vue")
  },
  methods: {
    install() {
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === "accepted") {
          this.showOpenApp = true;
          this.showInstallPrompt = false;
        } else {
          console.log("User dismissed the install prompt");
        }
      });
    },
    open() {
      window.open("https://cazzate.aiosa.net/");
    }
  },
  data() {
    return {
      deferredPrompt: null,
      showInstallPrompt: false,
      showOpenApp: false
    };
  },
  created() {
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      deferredPrompt = e;
      this.showInstallPrompt = true;
    });

    window.addEventListener("appinstalled", () => {
      alert("installata");
    });
  }
};
</script>